// Photos are now clustered together with markers in render-3d-markers.
// This file is kept only for the buildPhotoMarkerElement export used by add-photo.js.

function normaliseColor(color) {
  if (!color) return '#FF0000'
  const c = color.startsWith('#') ? color : '#' + color
  return c.length > 7 ? '#' + c.slice(-6) : c
}

export function buildPhotoMarkerElement(colorRaw, imageUrl) {
  const c = normaliseColor(colorRaw)
  const el = document.createElement('div')
  if (imageUrl) {
    el.style.cursor = 'pointer'
    el.innerHTML = `
      <svg width="40" height="50" viewBox="0 0 40 50" xmlns="http://www.w3.org/2000/svg">
        <circle cx="20" cy="20" r="17" fill="${c}"/>
        <polygon points="20,47 12,35 28,35" fill="${c}"/>
        <foreignObject x="5" y="5" width="30" height="30" style="overflow:visible">
          <div xmlns="http://www.w3.org/1999/xhtml"
               style="width:30px;height:30px;border-radius:50%;overflow:hidden">
            <img src="${imageUrl}" style="width:100%;height:100%;object-fit:cover;display:block"/>
          </div>
        </foreignObject>
      </svg>`
    const img = el.querySelector('img')
    if (img) {
      img.onerror = () => {
        img.onerror = null
        img.src = `${imageUrl}${imageUrl.includes('?') ? '&' : '?'}_cb=${Date.now()}`
      }
    }
  } else {
    el.style.cursor = 'pointer'
    el.innerHTML = `
      <svg width="40" height="50" viewBox="0 0 40 50" xmlns="http://www.w3.org/2000/svg">
        <defs><clipPath id="pc2"><circle cx="20" cy="20" r="15"/></clipPath></defs>
        <circle cx="20" cy="20" r="17" fill="${c}"/>
        <circle cx="20" cy="20" r="15" fill="${c}"/>
        <g clip-path="url(#pc2)">
          <svg x="5" y="5" width="30" height="30" viewBox="0 0 600 600">
            <defs><clipPath id="ci"><circle cx="300" cy="300" r="300"/></clipPath></defs>
            <g clip-path="url(#ci)">
              <rect width="600" height="600" fill="#7fe6ff"/>
              <circle cx="150" cy="150" r="50" fill="#ffeb00"/>
              <polygon points="0,600 200,300 400,600" fill="#6af74f"/>
              <polygon points="200,600 450,200 600,600" fill="#32a632"/>
            </g>
          </svg>
        </g>
        <polygon points="20,47 12,35 28,35" fill="${c}"/>
      </svg>`
  }
  return el
}

// No-op — rendering is handled by render-3d-markers
const RenderPhotos = () => null
export default RenderPhotos
